import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, RcmsFavorecido } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class RcmsFavorecidorService extends BaseResourceService<RcmsFavorecido> {

  constructor(
    protected injector: Injector
  ) {
    super(`rcms-favorecidos`, injector);
  }

}
